import { render, staticRenderFns } from "./PaperReport.vue?vue&type=template&id=6361bc44&scoped=true"
import script from "./PaperReport.vue?vue&type=script&lang=js"
export * from "./PaperReport.vue?vue&type=script&lang=js"
import style0 from "./PaperReport.vue?vue&type=style&index=0&id=6361bc44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361bc44",
  null
  
)

export default component.exports